import { authHeader } from './auth-header';

export default{
    login,
    logout,
    register,
    getAll,
    getDobFromIdNumber,
    checkrole
};

function login(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    };
    return fetch(`/users/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}
function checkrole(role){
    let allowedRole = this.$store.state.layout.role
    let hasRole = allowedRole.filter(element=>element.Action==role)
    console.log('hasRole',hasRole)
    if(hasRole.length>0){
        console.log('role  allowed',role)
        return true
    }else{
        console.log('role not allowed',role)
        return false

    }
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch(`/users/register`, requestOptions).then(handleResponse);
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
function getDobFromIdNumber(idNumber){
    // if(!idNumber){
    //     return "";
    // }
    // if(idNumber.length<12){
    //     return "";
    // }
    if(idNumber.length>=12){
        let year = idNumber.substring(0,2)
        let day = idNumber.substring(4,6)
        let month = idNumber.substring(2,4)
        console.log(year,day,month)
        if(month.match(/[^$,.\d]/)){
            console.log('invalid')
            return "invalid"
        }
        else if(parseInt(month)>12 || parseFloat(day)>31){
            return "invalid"
        }
       else  if(parseInt(year)<30){
            return day+'/'+month+'/20'+year
        }else{
            return day+'/'+month+'/19'+year
        }
    }
    else
    return "invalid"

}
